import { useRef } from "react";
import { Alert, Snackbar } from "@mui/material";

import { useSnackbarStore } from "@/stores/snackbarStore";

import { PersistentErrorContent } from "./PersistentErrorContent";

export const GlobalSnackbar = () => {
  const current = useSnackbarStore((state) => state.current);
  const dismiss = useSnackbarStore((state) => state.dismiss);

  const lastMessageRef = useRef(current);
  if (current) {
    lastMessageRef.current = current;
  }

  const displayMessage = current || lastMessageRef.current;

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    event?.stopPropagation();
    dismiss();
  };

  if (!displayMessage) return null;

  const handleClick = () => {
    if (displayMessage.onClick) {
      displayMessage.onClick();
    }
  };

  const isClickable = !!displayMessage.onClick;
  const { capturedError } = displayMessage;

  return (
    <Snackbar
      open={!!current}
      autoHideDuration={displayMessage.autoHideDuration}
      onClose={handleClose}
      anchorOrigin={displayMessage.anchorOrigin}
    >
      <Alert
        onClose={handleClose}
        severity={displayMessage.severity}
        variant="filled"
        onClick={handleClick}
        sx={{
          width: "100%",
          whiteSpace: "pre-line",
          "& .MuiAlert-icon": {
            alignItems: "center",
          },
          ...(isClickable && {
            cursor: "pointer",
            "&:hover": {
              opacity: 0.9,
            },
          }),
        }}
      >
        {capturedError ? (
          <PersistentErrorContent
            message={displayMessage.message}
            capturedError={capturedError}
          />
        ) : (
          displayMessage.message
        )}
      </Alert>
    </Snackbar>
  );
};
